import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DownloadIcon from "@mui/icons-material/Download";

import CloseIcon from "@mui/icons-material/Close";
import USRIView from "./USRIView";

export default function ReportDialog(props) {
	const {
		open,
		setOpen,
		reportData = [],
		reportType,
		handleDownloadAllReports,
	} = props;

	const handleClose = () => {
		setValue(0);
		setOpen(false);
	};

	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	if (reportType === "pub") {
		return (
			<div>
				<Dialog
					open={open}
					onClose={handleClose}
					fullScreen
					sx={{
						background: "#275d38",
						"& .MuiPaper-root": {
							background: "#275d38",
						},
					}}
					className="bg-primary"
				>
					{reportData.map((data, index) => {
						return (
							<USRIView
								key={index}
								reportData={data}
								reportType={reportType}
							/>
						);
					})}

					<DialogActions className="fixed top-2 right-10 z-50">
						<button
							onClick={handleClose}
							className="p-2  text-white"
						>
							<CloseIcon
								size={60}
								sx={{ width: 50, height: 50 }}
							/>
						</button>
					</DialogActions>
				</Dialog>
			</div>
		);
	} else {
		return (
			<div>
				<Dialog
					open={open}
					onClose={handleClose}
					fullScreen
					className="transition duration-300 ease-in-out"
					sx={{
						background: "#275d38",
						"& .MuiPaper-root": {
							background: "#275d38",
							display: "flex",
							flexDirection: "row",
							position: "relative",
						},
					}}
				>
					<div className="w-[240px] absolute top-0 right-0 text-primary  z-20 flex justify-end border--2 border-gray-300">
						<button
							onClick={handleClose}
							className="p-[1px]   "
						>
							<CloseIcon
								sx={{
									width: 45,
									height: 45,
									color: "white",
								}}
							/>
						</button>
					</div>
					<div className="w-[240px] absolute bottom-0 right-0 text-primary bg-white flex justify-center items-center z-20 p-2">
						<button
							onClick={handleDownloadAllReports}
							className="py-2 px-4 font-semibold border-2 underline hover:ring-2 ring-inset  border-white rounded-full text-primary    bg-white transition duration-300 ease-in-out flex items-center"
						>
							Download All Reports
							<DownloadIcon />
						</button>
					</div>

					{/* Left-side content */}
					<div
						className="flex-1 overflow-y-auto  bg-black "
						// style={{
						// 	scrollbarWidth: "1px", // Firefox
						// 	"-ms-overflow-style": "none", // IE/Edge
						// }}
					>
						<style jsx>{`
							div::-webkit-scrollbar {
								width: 4px; /* width of the scrollbar */
							}
						`}</style>
						{reportData.map((data, index) => (
							<div
								key={index}
								role="tabpanel"
								hidden={value !== index}
								id={`tabpanel-${index}`}
								aria-labelledby={`tab-${index}`}
							>
								{value === index && (
									<USRIView
										reportData={data}
										reportType={reportType}
									/>
								)}
							</div>
						))}
					</div>
					{/* Right-side vertical tabs */}
					<Tabs
						value={value}
						onChange={handleChange}
						orientation="vertical"
						variant="scrollable"
						scrollButtons="auto"
						aria-label="Vertical tabs"
						sx={{
							borderLeft: 1,
							borderColor: "divider",
							backgroundColor: "",
							minWidth: "240px",
							maxWidth: "240px",
							paddingTop: "3rem", // adjust as needed for spacing
							position: "relative",
						}}
						className="bg- "
					>
						{reportData.map((data, index) => (
							<Tab
								key={index}
								label={
									<div className="flex items-center justify-between w-full p-2 text-left ">
										<div>
											<p>{data.header.class_title}</p>
											<p className="text-gray-400">
												{data.header.academic_year}
											</p>
										</div>
									</div>
								}
								id={`tab-${index}`}
								aria-controls={`tabpanel-${index}`}
								sx={{
									color: "white",
									alignItems: "flex-start",
									textAlign: "left",
									// borderTop: "1px solid #275d38",
									// borderBottom: "1px solid #275d38",
									"&:hover": {
										backgroundColor: "#003216",
										color: "white",
									},
									"&.Mui-selected": {
										backgroundColor: "#003216",
										color: "#FFB600",
									},
								}}
							/>
						))}
					</Tabs>
				</Dialog>
			</div>
		);
	}
}
